import React from 'react';
import { Users, CalendarCheck, DollarSign } from 'lucide-react';
import { TabBar } from '../../components/ui';

const TABS = [
  { id: 'team', label: 'Team', to: '/dashboard/staff', icon: Users },
  { id: 'attendance', label: 'Attendance', to: '/dashboard/staff/attendance', icon: CalendarCheck },
  { id: 'salary', label: 'Salary', to: '/dashboard/staff/salary', icon: DollarSign },
];

/** Staff hub tab strip — Team / Attendance / Salary. */
export default function StaffTabs({ active }) {
  return <TabBar tabs={TABS} active={active} ariaLabel="Staff sections" />;
}
